import { breadcrumb } from './breadcrumb';

export const mailer = {
  breadcrumb,

  mailing: {
    new_status: {
      moderation: 'Moderation',
      rejected: 'Rejected',
      pending: 'Pending',
      processing: 'Processing',
      processed: 'Processed',
      finished: 'Finished',
      failed: 'Failed',
    },

    modal: {
      remove: {
        content: 'Are you sure you want to delete the {name} mailing list?'
      },
      view: {
        title: 'Message parts'
      },
      part_number: 'Message part',
      status: 'Status',
      client_cost: 'Cost'
    },

    form: {
      block: {
        sender: {
          title: 'Sender'
        },

        content: {
          title: 'Content'
        },

        recipients: {
          title: 'Recipients'
        },

        sms: {
          placeholder: 'Your message'
        },

        date: {
          title: 'Delivery date',
          action: 'Delay mailing'
        }
      },

      field: {
        sender: {
          title: 'Name'
        },

        title: {
          title: 'Mailing name',
          placeholder: 'Enter the title'
        },

        template: {
          title: 'Template',
          save_template: 'Save Template'
        },

        macros: {
          title: 'Macro'
        },

        body: {
          title: 'Body'
        }
      }
    }
  },

  message: {
    field: {
      src: 'Virtual Sender Number',
      dst: 'Recipient Number',
      created_at: 'Date received message',
      body: 'Message text',
      parts: 'Parts',
      name: 'Mailing name',
      source_type: 'Sourse',
      total_parts: 'Total parts',
      sender_name: 'Sender name'
    },

    noty: {
      balance:
        'Insufficient funds on the account. SMS-mailing paused. Please make payment into your account.'
    },

    setting: {
      title: 'Settings',
      field: {
        webhook_sms_state: {
          name: 'Postback for SMS status'
        },
        webhook_incoming_sms: {
          name: 'Webhook incoming SMS',
          description: 'Enter your URL and we will be able to send you data by incoming SMS.',
          requirement:
            'Requirements: this URL must be accessible through a POST request for it and give status - 200. Data format: json. Example: {"src":"89876543210", "dst": "80123456789", "body": "sms text"}'
        }
      }
    },

    status: {
      delivered: 'Delivered',
      sent: 'Sent',
      pending: 'Pending',
      not_delivered: 'Not Delivered',
      failed: 'Failed',
      rejected: 'Rejected',
      expired: 'Expired',
      processing: 'Processing'
    },

    status_table: {
      sent: 'Sent',
      pending: 'Pending',
      delivered: 'Delivered',
      active: 'Active',
      not_delivered: 'Not Delivered',
      failed: 'Failed',
      error: 'Error',
      rejected: 'Rejected',
      processing: 'Processing',
      resending: 'Resending',
      expired: 'Expired'
    }
  },

  template: {
    fields: {
      body: 'Body'
    },

    modal: {
      remove: {
        content: 'Are you sure you want to delete the template {name}?'
      }
    }
  },

  buttons: {
    add_senders: 'Add sender'
  },

  sender: {
    state: {
      all: 'All',
      moderation: 'Moderation',
      canceled: 'Rejected',
      active: 'Active',
      deactivated: 'Deleted',
      new: 'New',
      on_deactivation: 'On deactivation'
    },

    table: {
      name: "Sender's name",
      description: 'Description',
      cost: 'Cost',
      deactivate: 'Deactivate'
    },

    form: {
      create: {
        description:
          "Sender's name can contain up to 11 latin letters, numbers, and special characters(.,-_)."
      }
    },

    modal: {
      add: {
        title: 'Add sender',
        description:
          'After sending a request to add a Sender, you will see in the Description column a list of documents required for registration and the monthly cost of the Sender.',
        sender_name: "Sender's name"
      },
      remove: {
        content: 'Are you sure you want to delete the sender {name}?'
      },
      deactivate: {
        content: 'Are you sure you want to deactivate the {name}?'
      }
    }
  },

  tooltips: {
    delayed_until: 'Time is in user UTC',
    db_range: 'Specifying the range of numbers to be included in the newsletter'
  },

  archived_stats: {
    general: {
      filter: {
        group_by: {
          title: 'Group by',
          values: {
            day: 'Day',
            mailing: 'Mailing',
            country: 'Country',
            operator: 'Operator',
            sender: 'Sender'
          }
        }
      }
    }
  },
  stats: {
    general: {
      filter: {
        group_by: {
          title: 'Group by',
          values: {
            day: 'Day',
            mailing: 'Mailing',
            country: 'Country',
            sender: 'Sender',
            network: 'Operator'
          }
        },

        sender: {
          title: 'Sender'
        },

        source: {
          title: 'Source',
          values: {
            web: 'Web interface',
            api: 'API'
          }
        }
      },

      field: {
        total: 'Total',
        cost: 'Cost',
        group: 'Date'
      },

      block: {
        main: 'Summary table'
      }
    },

    detailed: {
      filter: {
        number: {
          title: 'Number'
        },
        status: {
          title: 'Status'
        },
        mailing: {
          title: 'Mailing'
        }
      },
      total: 'Elements count'
    }
  },
  not_sender: {
    not_sender: 'You don’t have approved Sender ID.',
    to_create: 'To create a new mailing, follow the',
    link: 'link',
    and_to_create: 'and create a new Sender ID'
  },
  export: {
    not_export: 'There is no data to export. Try changing the filter conditions.'
  }
};
